<div class="container" #clockInOutPage style="padding-top: 50px;">
    <div class="row">
        <div class="col-xl-3 col-lg-2 col-md-1 d-none d-md-block "></div>
        <div class="col-xl-6 col-lg-8 col-md-10 col-12">
            <div class="alert alert-warning" *ngIf="requestingLocation  && !clockActionPerformed">
                <span style="font-size: 18px;">Obtaining Location</span>
            </div>
            <div *ngIf="!requestingLocation && !clockActionPerformed">
                <span *ngIf="!geolocationEnabled" class="alert alert-danger" style="font-size: 18px;">Location Not Available</span>
                <span *ngIf="position != null" class="alert alert-success" style="font-size: 18px;">Location Found.&nbsp;<span *ngIf="!clockInUsePhase && clockStatus">Processing...</span></span>
            </div>
            <div *ngIf="clockActionPerformed">
                <span *ngIf="!clockActionSuccess" class="alert alert-danger" style="font-size: 18px;">{{message}}</span><br />
                <div *ngIf="clockActionSuccess" class="alert alert-success" style="display: block">
                    <span style="font-size: 18px;">{{message}}</span><br />
                    <span style="font-size: 18px;">Redirecting back to login page...</span>
                </div>
            </div>
            <a href="/Account/Login" class="btn btn-primary" style="margin-top:12px;" *ngIf="clockActionPerformed && !clockActionSuccess">Back</a>
            <a href="/Home/Index" class="btn btn-primary" *ngIf="!kioskLogin && clockActionPerformed && clockActionSuccess" style="margin-top:12px;">Stay logged in</a>
            <button type="button" class="btn btn-danger" [disabled]="performingClockAction"
                    *ngIf="(!clockInUsePhase || clockStatus) && (requestingLocation || !geolocationEnabled) && !clockActionPerformed && (!requireSign || (requireSign && !clockStatus))"
                    (click)="postClockAction(true)">
                Clock In/Out Without Location
            </button>
            <button type="button" class="btn btn-success" [disabled]="performingClockAction"
                    *ngIf="!clockInUsePhase && !requestingLocation && position != null && !clockActionPerformed && (!requireSign || (requireSign && !clockStatus))"
                    (click)="postClockAction(false)">
                Clock In/Out
            </button>
        </div>
    </div>

    <div class="row" *ngIf="requireSign && clockStatus && !(!kioskLogin && clockActionPerformed) && !clockActionPerformed">
        <div class="col-xl-3 col-lg-2 col-md-1 d-none d-md-block"></div>
        <div class="col-xl-6 col-lg-8 col-md-10 col-12">
            <div class="alert alert-warning" *ngIf="customMsg != null">
                <quill-view disabled [content]="customMsg"></quill-view>
            </div>
            <div class="card border" [style.width.px]="panelWidth" style="margin-bottom:20px">
                <div class="card-body" [style.width.px]="panelWidth" style="background-color:#d4d4d4;border:1px solid black;border-radius:5px;">
                    <div class="alert alert-info" style="margin:10px;" *ngIf="showClickMsg">Press "Clear" before generating your signature image.</div>
                    <div class="m-signature-pad">
                        <div class="m-signature-pad--body" [ngClass]="{ 'invalid': redBorder == true}" [hidden]="submitSignImg != null">
                            <ngx-signaturepad [width]="panelWidth - 35" [height]="150" #signaturePad></ngx-signaturepad>
                        </div>
                        <div *ngIf="submitSignImg != null" style="background-color:white;border:1px solid black">
                            <img [src]="submitSignImg" [style.max-width.px]="panelWidth - 50" />
                        </div>
                        <div class="m-signature-pad--footer">
                            <div style="text-align: center;font-size: 12px;">Sign above</div>
                            <button type="button" class="btn btn-outline-dark" (click)="clear()">Clear</button>
                            <button type="button" class="btn btn-outline-dark" (click)="clickSign('full')" *ngIf="!hideClick">Generate Signature</button>
                            <div class="alert alert-warning" style="margin:10px;">By signing above, I agree that the signature and initials will be the electronic representation of my signature and initials for all purposes when I (or my agent) use them on documents, including legally binding contracts - just the same as a pen-and-paper signature or initial.</div>
                        </div>
                    </div>
                </div>
            </div>
            <button class="btn btn-success" type="button" (click)="clockOutClicked()" [disabled]="disableSubmitSign">Submit Clock-Out</button>
        </div>
    </div>
    <div class="row" *ngIf="clockInUsePhase && !clockStatus && !clockActionPerformed">
        <div class="col-xl-3 col-lg-2 col-md-1 d-none d-md-block"></div>
        <div class="col-xl-6 col-lg-8 col-md-10 col-12">
            <div class="card border">
                <div class="card-body row">
                    <div class="d-none d-lg-block col-xl-2 col-lg-2"></div>
                    <div class="col-xl-8 col-lg-8 col-md-12 col-12">
                        <label><strong>Job:</strong></label>
                        <ng-select style="margin-bottom: 12px;"
                                   [items]="jobs"
                                   bindLabel="DisplayValue"
                                   [clearable]="false"
                                   [(ngModel)]="formData.selectedJob"
                                   dropdownPosition="bottom"
                                   (change)="jobChanged()"
                                   [searchFn]="searchJobs">
                        </ng-select>
                        <label><strong>Phase:</strong></label>
                        <ng-select style="margin-bottom: 12px;"
                                   [items]="phases"
                                   bindLabel="PhaseDescription"
                                   [clearable]="false"
                                   [(ngModel)]="formData.selectedPhase"
                                   dropdownPosition="bottom"
                                   [searchFn]="searchPhases">
                        </ng-select>
                        <div class="row">
                            <div class="col-lg-12">
                                <button type="button" class="btn btn-danger" [disabled]="performingClockAction || (((formData.selectedJob?.JCJMKeyID == null || formData.selectedPhase?.JCJPKeyID == null) && !tCClockIOIgnoreJobPhase) || (tCClockIOIgnoreJobPhase && (formData.selectedJob == null || formData.selectedPhase == null)))"
                                        *ngIf="(requestingLocation || !geolocationEnabled)"
                                        (click)="postClockAction(true)">
                                    Clock In Without Location
                                </button> <img src="/Cache/images/icon_load.gif" alt="Loading..." *ngIf="performingClockAction" />
                                <button type="button" class="btn btn-success" *ngIf="!requestingLocation && position != null" [disabled]="performingClockAction || (((formData.selectedJob?.JCJMKeyID == null || formData.selectedPhase?.JCJPKeyID == null) && !tCClockIOIgnoreJobPhase) || (tCClockIOIgnoreJobPhase && (formData.selectedJob == null || formData.selectedPhase == null)))"
                                        (click)="postClockAction(false)">
                                    Clock In
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="d-none d-lg-block col-xl-2 col-lg-2"></div>
                </div>
            </div>
        </div>

    </div>
</div>